<template>
    <div class="input-row">
        <div class="row-input-item left">
            <label class="row-input-field-label" for="username">Username</label>
            <input type="text" name="username" class="row-input-field" v-model="adminAccount.username" disabled>
        </div>
        <div class="row-input-item middle">
            <label class="row-input-field-label" for="email">Email</label>
            <input type="text" name="email" class="row-input-field" v-model="adminAccount.userEmail" disabled>
        </div>
        <div class="row-input-item right">
            <!-- <router-link :to="{name:'userAccountManagementForUser', params:{userID: adminAccount.id}}">See Accounts</router-link> -->
        </div>
    </div>    
</template>

<script>
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'


import { mapGetters } from 'vuex'
import { mapState, mapMutations } from 'vuex'


export default {
    name: 'AdminAccountRow',

    props: ['adminAccount'],

    computed:{
        ...mapState([
            'userInfo'
        ]),

    },


    
}
</script>

<style scoped>

.input-row{
    width: 100%;
    vertical-align: middle;
    border-bottom: 1px solid #DBDBDB
}

.row-input-field{
    width: 85%;
    border: none;
    background-color: transparent;
    font-size: 1em;
    line-height: 1.5;
}

.row-input-field-label{
    display: none;
}

.row-input-item{
    display: inline-block;
    padding: 8px 0px 8px 12px;
}

.left{
    width: 40%
}

.middle{
    width: 45%
}

.right{
    width: 15%
}


@media screen and (max-width: 811px){
    .row-input-field-label{
        display: inline-block;
        padding-right: 6px;
        font-weight: 600;
        width: 25%
    }

    .row-input-field{
        width: 75%;
        border: none;
        font-size: 1em;
    }

    .row-input-item{
        display: block;
        width: 100%;
    }
}
</style>